var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-layout",
        { staticClass: "elevation-1" },
        [
          _c(
            "v-flex",
            {
              staticClass: "extra-content h-130",
              class: {
                "pt-12": _vm.mdAndUp,
                "pt-5 px-10": _vm.smAndDown,
                "px-5": (_vm.xl || _vm.smAndDown) && _vm.showCards,
                "pl-6": _vm.lg && _vm.showCards,
                "pl-1 pr-9": _vm.md,
              },
              attrs: { xs12: "", sm12: "", md12: "", lg12: "", xl12: "" },
            },
            [
              _c(
                "v-row",
                { attrs: { justify: "center" } },
                [
                  _c(
                    "v-col",
                    {
                      class: { "ta-c": _vm.smAndDown },
                      attrs: {
                        cols: "12",
                        xl: _vm.showCards ? 7 : 11,
                        lg: _vm.showCards ? 8 : 11,
                        md: _vm.showCards ? 8 : 11,
                        sm: "12",
                      },
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass: "page-heading",
                          class: {
                            "ml-n3":
                              _vm.smAndDown || _vm.xl || _vm.lg || _vm.md,
                          },
                        },
                        [_vm._v("My Shipments")]
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        { class: { "px-5": _vm.smAndDown }, attrs: { justify: "center" } },
        [
          _c(
            "v-col",
            {
              class: { "px-4": _vm.smAndDown },
              attrs: {
                sm: "12",
                lg: _vm.showCards ? 8 : 11,
                xl: _vm.showCards ? 7 : 11,
                md: _vm.showCards ? 8 : 11,
              },
            },
            [
              _c(
                "v-row",
                {
                  staticClass: "mt-7 filter-button-row",
                  class: { "mb-16": _vm.mdAndUp, "mb-10": _vm.smAndDown },
                },
                [
                  _c(
                    "v-col",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: !_vm.hideCountLabel,
                          expression: "!hideCountLabel",
                        },
                      ],
                      staticClass: "results-header my-shipments",
                      class: {
                        "pl-3": _vm.mdAndUp && _vm.showCards,
                        "ta-c": _vm.smAndDown,
                        "pr-0": _vm.md,
                        "pr-3": _vm.sm,
                        "pl-0": _vm.showGrid,
                      },
                      attrs: {
                        cols: "12",
                        sm: "7",
                        md: "5",
                        lg: "3",
                        xl: _vm.myShipmentsButtonsXlSize == 8 ? 4 : 5,
                      },
                    },
                    [
                      _c("label", { staticClass: "search-result" }, [
                        _vm._v(
                          _vm._s(
                            _vm.totalCount > 1000
                              ? 1000
                              : _vm.formatNumber(_vm.totalCount)
                          )
                        ),
                      ]),
                      _c("span", { staticClass: "shipments-results-text" }, [
                        _vm._v(" shipment results"),
                      ]),
                      _c("span", { staticClass: "shipments-text" }, [
                        _vm._v(" shipments "),
                      ]),
                    ]
                  ),
                  _c(
                    "v-col",
                    {
                      staticClass: "my-shipments controls",
                      class: {
                        "pr-3": _vm.sm,
                        "pr-0": _vm.mdAndUp,
                      },
                      attrs: {
                        cols: "12",
                        sm: "12",
                        md: "12",
                        lg: _vm.myShipmentsButtonsLgSize,
                        xl: _vm.myShipmentsButtonsXlSize,
                      },
                    },
                    [
                      _c("my-shipment-buttons", {
                        attrs: { "show-combine": _vm.showCombine },
                        on: {
                          csvExport: _vm.csvExportV2,
                          displayFilters: function ($event) {
                            _vm.displayFilters = true
                          },
                          clearFilters: _vm.clearFiltersV2,
                          combine: _vm.combine,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "v-row",
                { staticClass: "mt-n8" },
                [
                  _vm.showCards
                    ? _c(
                        "v-col",
                        {
                          key: _vm.gridRenderKey,
                          attrs: {
                            xs12: "",
                            sm12: "",
                            md12: "",
                            lg12: "",
                            xl12: "",
                          },
                        },
                        _vm._l(_vm.page, function (ship) {
                          return _c(
                            "v-layout",
                            { key: ship.shipmentId, attrs: { row: "" } },
                            [
                              _c("shipment-card", {
                                attrs: {
                                  shipment: ship,
                                  selectable: _vm.isCardSelectable(ship),
                                },
                                on: {
                                  copied: function (id) {
                                    return _vm.copied(id)
                                  },
                                  showDetails: _vm.showDetails,
                                  confirmDelete: function (id) {
                                    return _vm.confirmDelete(id)
                                  },
                                  confirmCancel: function (id) {
                                    return _vm.confirmCancel(id)
                                  },
                                  makeCopy: function (id) {
                                    return _vm.makeCopy(id)
                                  },
                                  "no-tracking": _vm.noTracking,
                                  "open-docs": _vm.openDocs,
                                  unmerged: _vm.unmerged,
                                },
                              }),
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _vm.showGrid
                    ? _c(
                        "v-col",
                        {
                          staticClass: "my-shipments-grid-wrapper mb-5",
                          attrs: {
                            xs12: "",
                            sm12: "",
                            md12: "",
                            lg12: "",
                            xl12: "",
                          },
                        },
                        [
                          _c("my-shipments-grid", {
                            attrs: { page: _vm.page },
                            on: {
                              copied: function (id) {
                                return _vm.copied(id)
                              },
                              showDetails: _vm.showDetails,
                              confirmDelete: function (id) {
                                return _vm.confirmDelete(id)
                              },
                              confirmCancel: function (id) {
                                return _vm.confirmCancel(id)
                              },
                              makeCopy: function (id) {
                                return _vm.makeCopy(id)
                              },
                              "no-tracking": _vm.noTracking,
                              "open-docs": _vm.openDocs,
                              unmerged: _vm.unmerged,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              ),
              _vm.showNoData
                ? _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        { staticClass: "ta-c", attrs: { cols: "12" } },
                        [_c("no-data")],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      !_vm.loading && _vm.shipments.length && _vm.showPagingV2
        ? _c(
            "v-layout",
            { staticClass: "mb-8" },
            [
              _c(
                "v-flex",
                { staticClass: "mt-3" },
                [
                  _c("v-pagination", {
                    staticClass: "pl-3",
                    attrs: { length: _vm.pagingLengthV2, "total-visible": 10 },
                    on: { input: _vm.pageChangeV2 },
                    model: {
                      value: _vm.currentPage,
                      callback: function ($$v) {
                        _vm.currentPage = $$v
                      },
                      expression: "currentPage",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-snackbar",
        {
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function (ref) {
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { color: "#007BFF", text: "" },
                        on: {
                          click: function ($event) {
                            _vm.snackbar = false
                          },
                        },
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v(" Close ")]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.snackbar,
            callback: function ($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar",
          },
        },
        [
          _c("img", {
            staticClass: "success-icon",
            attrs: { src: _vm.ic_green_success_checkmark },
          }),
          _vm._v(" " + _vm._s(_vm.snackbarText) + " "),
        ]
      ),
      _c(
        "v-snackbar",
        {
          scopedSlots: _vm._u([
            {
              key: "action",
              fn: function (ref) {
                var attrs = ref.attrs
                return [
                  _c(
                    "v-btn",
                    _vm._b(
                      {
                        attrs: { color: "#007BFF", text: "" },
                        on: {
                          click: function ($event) {
                            _vm.snackbarError = false
                          },
                        },
                      },
                      "v-btn",
                      attrs,
                      false
                    ),
                    [_vm._v(" Close ")]
                  ),
                ]
              },
            },
          ]),
          model: {
            value: _vm.snackbarError,
            callback: function ($$v) {
              _vm.snackbarError = $$v
            },
            expression: "snackbarError",
          },
        },
        [
          _c("img", {
            staticClass: "success-icon",
            attrs: { src: _vm.ic_warning_orange },
          }),
          _vm._v(" " + _vm._s(_vm.snackbarErrorText) + " "),
        ]
      ),
      _c("br"),
      _c(
        "v-dialog",
        {
          attrs: { scrollable: "", width: _vm.filtersWidth, eager: "" },
          model: {
            value: _vm.displayFilters,
            callback: function ($$v) {
              _vm.displayFilters = $$v
            },
            expression: "displayFilters",
          },
        },
        [
          _c("shipment-filters", {
            attrs: { searchInProgress: _vm.loading },
            on: {
              search: _vm.search,
              close: function ($event) {
                _vm.displayFilters = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "navigation-details",
          class: {
            active: _vm.displayDetails,
            "w-100-pct": _vm.smAndDown,
          },
        },
        [
          _c("shipment-overview", {
            attrs: { shipment: _vm.selectedShipment },
            on: {
              hide: function ($event) {
                return _vm.setDisplayDetails(false)
              },
              copied: _vm.copied,
              "open-docs": _vm.openDocsAndScrollUp,
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "546px" },
          model: {
            value: _vm.displayConfirmDelete,
            callback: function ($$v) {
              _vm.displayConfirmDelete = $$v
            },
            expression: "displayConfirmDelete",
          },
        },
        [
          _c("confirm-delete-shipment", {
            attrs: { deleting: _vm.deleting },
            on: {
              close: function ($event) {
                _vm.displayConfirmDelete = false
              },
              softDeleteShipment: _vm.softDeleteShipment,
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px" },
          model: {
            value: _vm.displayConfirmCancel,
            callback: function ($$v) {
              _vm.displayConfirmCancel = $$v
            },
            expression: "displayConfirmCancel",
          },
        },
        [
          _c("confirm-cancel-edi-shipment", {
            on: {
              close: function ($event) {
                _vm.displayConfirmCancel = false
              },
              cancelShipment: _vm.cancelShipment,
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "660px" },
          model: {
            value: _vm.showShipmentCancelFailedPopup,
            callback: function ($$v) {
              _vm.showShipmentCancelFailedPopup = $$v
            },
            expression: "showShipmentCancelFailedPopup",
          },
        },
        [
          _c("cancel-edi-shipment-failed", {
            attrs: {
              info: _vm.shipmentCancelFailedInfoComputed,
              state: _vm.currentCancellationStateComputed,
            },
            on: {
              close: function () {
                _vm.shipmentCancelFailedInfo = null
                _vm.showShipmentCancelFailedPopup = false
              },
              successfullyCancelled: _vm.successfullyCancelledManual,
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600px" },
          model: {
            value: _vm.showShipmentSuccessfullyCancelledPopup,
            callback: function ($$v) {
              _vm.showShipmentSuccessfullyCancelledPopup = $$v
            },
            expression: "showShipmentSuccessfullyCancelledPopup",
          },
        },
        [
          _c("shipment-successfully-cancelled", {
            attrs: { shipmentId: _vm.currentShipmentId },
            on: { close: _vm.shipmentSuccessfullyCancelledPopupClosed },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "546px" },
          model: {
            value: _vm.displayMakeCopy,
            callback: function ($$v) {
              _vm.displayMakeCopy = $$v
            },
            expression: "displayMakeCopy",
          },
        },
        [
          _c("copy-order", {
            attrs: { shipmentId: _vm.currentShipmentId },
            on: {
              hide: function ($event) {
                _vm.displayMakeCopy = false
              },
              copy: _vm.copyOrder,
            },
          }),
        ],
        1
      ),
      _c("documents", {
        attrs: {
          shipmentId: _vm.currentShipmentId,
          display: _vm.displayDocuments,
        },
        on: {
          hide: function ($event) {
            _vm.displayDocuments = false
          },
        },
      }),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "546px" },
          model: {
            value: _vm.displayNoTracking,
            callback: function ($$v) {
              _vm.displayNoTracking = $$v
            },
            expression: "displayNoTracking",
          },
        },
        [
          _c("no-external-tracking", {
            on: {
              displayNoTracking: function ($event) {
                _vm.displayNoTracking = false
              },
            },
          }),
        ],
        1
      ),
      _c(
        "v-dialog",
        {
          key: _vm.rerenderMergeWindow,
          attrs: { width: _vm.consolidationPopupWidth, scrollable: "" },
          model: {
            value: _vm.showMergeWindow,
            callback: function ($$v) {
              _vm.showMergeWindow = $$v
            },
            expression: "showMergeWindow",
          },
        },
        [
          _c("combine-orders", {
            attrs: { mergeFromCustPortal: true },
            on: {
              close: _vm.combineOrdersClosed,
              "copy-order-ids": _vm.copyOrderIds,
            },
          }),
        ],
        1
      ),
      _c(
        "v-overlay",
        { attrs: { value: _vm.loading, opacity: "0.9", color: "#fff" } },
        [
          _c(
            "v-row",
            { staticClass: "mt-n16" },
            [
              _c(
                "v-col",
                {
                  staticClass: "text-center",
                  class: { "px-6": _vm.smAndDown },
                },
                [
                  _c("img", {
                    staticClass: "rotating",
                    attrs: { src: _vm.ic_loader_blue_big, width: "86" },
                  }),
                  _c("p", { staticClass: "overlay-txt mt-5" }, [
                    _vm._v(_vm._s(_vm.loadingMsg)),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }